var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notify",class:_vm.computedClass},[_c('div',{staticClass:"icon"},[_c('i',{class:_vm.computedIcon})]),_c('div',{staticClass:"message"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }